import './App.css';
import React from 'react';
import MapContainer from './components/MapContainer'

function App() {
  return (
    <React.Fragment>

      <MapContainer />

    </React.Fragment>
  );
}

export default App;
